import { useQuery } from "@tanstack/react-query";
import type { DelayByShift } from "../../delays-report/models/DelayByShift";
import { getDelays } from "../../delays-report/repositories/DelaysReportRepository";

export const useDelaysReportQuery = (
  startDate: Date,
  endDate: Date,
  delayAreaAssetId: number,
  includeMicrodelays: boolean,
  onError?: (error: Error) => void,
) => {
  return useQuery({
    queryKey: [
      "delays-report",
      startDate.toISOString(),
      endDate.toISOString(),
      delayAreaAssetId,
      includeMicrodelays,
    ],
    meta: { realtime: ["DEL.GetDelays"] },
    queryFn: async ({ signal }) => {
      const resp = await getDelays(
        startDate,
        endDate,
        delayAreaAssetId,
        includeMicrodelays,
        signal,
      );
      if (resp.ok) {
        return (resp.data?.tables?.[0]?.rows ?? []) as DelayByShift[];
      }
      throw new Error(resp.message);
    },
    enabled: !!delayAreaAssetId,
    onError,
  });
};
